import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  CREATE_GROUP,
  createNewGroupFailed,
  createNewGroupSuccess,
} from "../actions/action_createGroup";
import util from "../../../global/utils/Helpers";
import { USER_IS_LOCKED } from "../../../global/utils/constants";
polyfill();

const getQuery = ({ email, subject }) => {
  return JSON.stringify({
    query: `
            mutation {
                createGroup(subjectid:"${subject}",email:"${email}")
          }`,
  });
};

const createGroupEpic = (action$) =>
  action$.pipe(
    ofType(CREATE_GROUP),
    mergeMap((action) =>
      fetch(util.getGqlApiUrl(), {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: getQuery(action.payload),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data.createGroup === USER_IS_LOCKED) {
            return createNewGroupFailed(data);
          }
          if (data.errors) {
            return createNewGroupFailed(data.errors);
          } else {
            return createNewGroupSuccess(data);
          }
        })
        .catch((error) => {
          return createNewGroupFailed(error);
        })
    )
  );

export default createGroupEpic;
